export enum FieldEnum {
  AccountNumber = 'accountNumber',
  Note = 'note',
  TaxId = 'taxId',
  CustomerNote = 'customerNote'
}
